import { generalSubscriptionsInput } from '../constants/subscriptions';
import {
  GeneratedCreateSubscriptionsInput,
  GeneratedSubscriptionType,
} from '../types/generated';

export const buildSubscriptions = ({
  artists,
  includeGeneral = false,
  productId,
  productRef,
  productTitle,
}: {
  includeGeneral?: boolean;
  artists: { name: string; internalId: string | null }[];
  productTitle: string;
  productId: string;
  productRef: string;
  isPreOrder: boolean;
}) => {
  const productSubscription: GeneratedCreateSubscriptionsInput = {
    type: GeneratedSubscriptionType.Product,
    objectId: productId,
    name: productTitle,
    ref: productRef,
  };

  const artistRefs = artists.map<GeneratedCreateSubscriptionsInput>((a) => ({
    type: GeneratedSubscriptionType.Artist,
    objectId: a.internalId!,
    ref: '',
    name: a.name,
  }));

  const toSubscribe = [productSubscription, ...artistRefs];

  if (includeGeneral) toSubscribe.push(generalSubscriptionsInput);

  return toSubscribe;
};
